export default "__VITE_ASSET__749b7ae2__"